import { render, staticRenderFns } from "./RootCol.vue?vue&type=template&id=f24f7be0&scoped=true&"
import script from "./RootCol.vue?vue&type=script&lang=ts&"
export * from "./RootCol.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24f7be0",
  null
  
)

export default component.exports